export default __webpack_public_path__ + "static/media/eye.1af918a0.jpg";